import React from 'react';
import { FaspioBridge } from '../../classes/FaspioBridge';
import { AsperaError } from '../../classes/AsperaError';
import { SubManager } from '../../classes/SubManager';
import { notification } from '../../services/NotificationService';
import { modal } from '../../services/ModalService';
import { safeZip } from '../../helpers/starterHelpers';
import { language } from '../../services/LanguageService';
import { AsperaDataTable } from '../AsperaDataTable';
import { AsperaWrapper } from '../AsperaWrapper';
import { getIconComponent } from '../Carbon';
import { ModalBodyConfirm } from '../ModalBodyConfirm';
/**
 * React Components
 *
 * The FaspioBridge view component renders the bridge list
 *
 * @example
 * ```javascript
 * <FaspioBridges serverUrl="" />
 * ```
 */
export class FaspioBridges extends React.Component {
    constructor() {
        super(...arguments);
        this.state = {
            loading: false,
        };
        this.subManager = new SubManager();
        this.delete = (items) => {
            const modalInfo = modal.prepare();
            const modalBodyProps = {
                modalClose: modalInfo.callback,
                description: language.get('faspio.confirmDeleteDescription'),
                list: items.map(item => item.name),
                warningDescription: language.get('faspio.actionCannotUndone'),
            };
            const modalProps = {
                danger: true,
                modalHeading: language.get('faspio.confirmDeleteTitle'),
                primaryButtonText: language.get('faspio.delete'),
            };
            const deleteCallback = () => {
                this.setState({ loading: true });
                const apiCalls = items.map(item => item.delete());
                this.subManager.setSubscription(safeZip(apiCalls).subscribe({
                    next: () => {
                        notification.create('success', language.get('faspio.deleteSuccess'));
                        this.setState({ loading: false });
                    },
                    error: error => {
                        new AsperaError('FaspioBridges: unable to delete bridges', error);
                        notification.create('error', language.get('faspio.deleteUnable'));
                        this.setState({ loading: false });
                    },
                }));
            };
            this.subManager.setSubscription(modal.create(modalInfo.id, modalProps, React.createElement(ModalBodyConfirm, Object.assign({}, modalBodyProps))).subscribe({
                next: () => {
                    deleteCallback();
                },
                error: () => { },
            }));
        };
    }
    get tableData() {
        const { serverUrl, openBridgeCallback } = this.props;
        return {
            tableId: 'faspio-bridges',
            disableFilter: true,
            disablePagination: true,
            apiData: {
                method: 'GET',
                url: `${serverUrl}/bridges`,
            },
            alterDataStore: items => items.map(item => new FaspioBridge(serverUrl, item)),
            handleClick: row => {
                if (typeof openBridgeCallback === 'function') {
                    openBridgeCallback(row);
                }
            },
            tableActions: [
                {
                    name: language.get('faspio.createNew'),
                    onClick: () => {
                        if (typeof openBridgeCallback === 'function') {
                            openBridgeCallback();
                        }
                    },
                    icon: getIconComponent('Add'),
                },
            ],
            batchActions: [
                {
                    name: language.get('faspio.delete'),
                    onClick: this.delete,
                    icon: getIconComponent('TrashCan'),
                },
            ],
            getOverflowMenu: () => [
                {
                    name: language.get('faspio.delete'),
                    onClick: item => this.delete([item]),
                    icon: getIconComponent('TrashCan'),
                },
            ],
            headerData: [
                {
                    name: language.get('faspio.name'),
                    key: 'displayName',
                    importance: 'primary',
                },
                {
                    name: language.get('faspio.local'),
                    key: 'displayLocalHosts',
                    secondaryKey: 'displayLocalPorts',
                    importance: 'tertiary',
                },
                {
                    name: language.get('faspio.forward'),
                    key: 'displayForwardHosts',
                    secondaryKey: 'displayForwardPorts',
                    importance: 'secondary',
                },
            ],
        };
    }
    componentWillUnmount() {
        this.subManager.unsubscribeAll();
    }
    render() {
        const { className } = this.props;
        const { loading } = this.state;
        return (React.createElement(AsperaWrapper, { disableWrapping: true, loading: loading, className: `faspio-bridge-list ${className ? className : ''}`, "data-auto": "faspio-bridge-list" },
            React.createElement(AsperaDataTable, Object.assign({}, this.tableData))));
    }
}
